import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { Deal, DealSearchParam } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DealService {

  private path = '/deals';

  constructor(private http: AlloxApiService) { }

  public search(param?: DealSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new Deal(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new Deal(obj))
    );
  }

  public post(item: Deal) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: Deal) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: Deal[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
